import {
    Bleed,
    BlockStack,
    Box,
    Button,
    Card,
    Divider,
    Icon,
    InlineStack,
    Text,
} from '@shopify/polaris';
import React, { useState } from 'react';
import { AlertTriangleIcon, LogoYoutubeIcon } from '@shopify/polaris-icons';
import ShopifyIcon from '../icons/ShopifyIcon';
import ShopifyIconColor from '../icons/ShopifyIconColor';
import Youtube from '../icons/Youtube';
import { useDispatch, useSelector } from 'react-redux';
import { checkEnabled } from '../../helper';
import useAuthenticatedFetch from '../../hooks/useAuthenticatedFetch';

const FullDivider = ({ top = 300, bottom = 300 }) => (
    <Box paddingBlockStart={top} paddingBlockEnd={bottom} >
        <Divider />
    </Box>
);

const CCSWarning = () => {

    const dispatch = useDispatch()
    const fetchJson = useAuthenticatedFetch()
    const { ConfigReducer } = useSelector(state => state)
    const { shop_id } = ConfigReducer
    const [Checking, setChecking] = useState(false)

    return (
        <Card padding={0}>
            {/* Header */}
            <div className="warning">
                <Box paddingInlineStart={400} paddingBlock={300}>
                    <InlineStack gap={200} blockAlign="center" align='start'>
                        <div>
                            <Icon source={AlertTriangleIcon} tone="warning" />
                        </div>
                        <Text as="h2" variant="headingMd">
                            Shipping rates are not showing at checkout
                        </Text>
                    </InlineStack>
                </Box>
            </div>

            <FullDivider top={0} />
            <Box padding={0} paddingInline={400}>
                {/* Content */}
                <BlockStack gap={300}>
                    <Text as="p" variant="bodyLg">
                        <span style={{ fontWeight: 500 }}>Carrier Calculated Shipping (CCS)</span> is disabled in your
                        Shopify settings.
                    </Text>

                    <Text as="p" variant="bodyLg">
                        Without CCS, real-time shipping rates cannot be displayed at checkout.
                    </Text>

                    <Bleed marginInline="400">
                        <div className="warning">
                            <Box paddingInlineStart={400} paddingBlock={200}>
                                <BlockStack align='center'>
                                    <Text as="p">
                                        This setting is managed by Shopify and must be enabled by Shopify
                                        Support or an eligible plan.
                                    </Text>
                                </BlockStack>
                            </Box>
                        </div>
                    </Bleed>

                    <Text as="p">
                        Once CCS is enabled, return here and click{' '}
                        <span style={{ fontWeight: 500 }}>Enable & Continue</span> to start using the app.
                    </Text>

                    {/* Light button */}
                    <InlineStack align="center">
                        <Button tone="success" variant="secondary"
                            loading={Checking} disabled={Checking}
                            onClick={() => checkEnabled(shop_id, setChecking, dispatch, fetchJson)}
                        >
                            Enable & Continue →
                        </Button>
                    </InlineStack>
                </BlockStack>
            </Box>

            <FullDivider bottom={0} />

            {/* Footer */}
            <Box padding={400} paddingBlockStart={0}>
                <InlineStack align="space-between" blockAlign="center">
                    <a
                        href="https://www.youtube.com/watch?v=nR34raPgyt8&list=PLkeebmoFziPwdGytDjJs51GuB3_OUzj5Q&index=2"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <InlineStack gap={200} wrap={false}>
                            <Icon source={Youtube} />
                            <Text as="span">Watch step-by-step video guide</Text>
                        </InlineStack>
                    </a>

                    <a
                        href="https://help.shopify.com/en/questions#/contact"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <InlineStack gap={200} wrap={false}>
                            <Icon source={ShopifyIconColor} />
                            <Text as="span">Contact Shopify Support</Text>
                        </InlineStack>
                    </a>
                </InlineStack>
            </Box>
        </Card>
    );
};

export default CCSWarning;

